import { environment } from '../../environments/environment';
interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'paypal', src: "https://www.paypal.com/sdk/js?client-id="+environment.PAYPAL_SITE_KEY+"&currency=USD"}
];

/**
 * user this syntax to call pay js. please check subscription plan module 
 
	this.scriptService.load('datatable').then((data:any) => {
		console.log('script loaded ', data);
	}).catch((error:any) => console.log(error));
*/
